<template>
    <div class="text-footer" style="width: 400px; padding-left:calc(50vw - 200px);padding-top: 10px;height: 30px;">
      <p>
        <a >备案号：</a>
        <a target="_blank" href="https://beian.miit.gov.cn" style="color:darkblue;" class="no-underline">黔ICP备18003927号</a>
        <el-text>&nbsp;&nbsp;&nbsp;&nbsp;</el-text>
        <a><img style="width: 12px; height: 12px"  :src="url" /></a> 
        <a  target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=52011502000703" style="color:darkblue;" class="no-underline">贵公网安备 52011502000703号</a>
      </p>
    </div>
</template>
<script>
export default {
  data() {
    return {
      url:require("@/assets/png/备案图标.png"),
    };
  },
};
</script>
<style>
.text-footer {
	color: #000000;
	font-size: 12px;
}
</style>